import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './styles/index.css'
import { HelmetProvider } from "react-helmet-async";

const root = document.getElementById('root')!
const app = (
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
)

// Pages pre-rendered at build time already hold their markup; hydrate it instead of
// rendering over it. Routes that aren't pre-rendered (e.g. the 404 page) arrive empty.
if (root.hasChildNodes()) {
  ReactDOM.hydrateRoot(root, app)
} else {
  ReactDOM.createRoot(root).render(app)
}
